import * as React from 'react';

import { Icon } from '../icon/icon.tsx';

import { useDevice, useWindowSize } from '../hooks.tsx';

import './menu-footer.css';

interface MenuFooterProps extends React.HTMLAttributes<HTMLDivElement> {
  userData: React.ReactNode;
  contextmenu: React.ReactNode;
  onToggle?: () => void;
}

const MenuFooter = React.forwardRef<HTMLDivElement, MenuFooterProps>(
  ({ userData, contextmenu, onToggle, ...props }, ref) => {
    const dimensions = useWindowSize();
    const device = useDevice(dimensions);

    return (
      <div ref={ref} className="menu-footer" {...props}>
        <div className="menu-footer-user">
          {device === 'mobile' && (
            <div className="menu-footer-menu-context">{contextmenu}</div>
          )}
          {userData}
        </div>
        {device === 'desktop' && (
          <div className="menu-footer-menu-context">{contextmenu}</div>
        )}
        {device === 'mobile' && (
          <button
            type="button"
            className="menu-footer-hamburger-trigger"
            onClick={onToggle}
          >
            <Icon type="menu" size="large" color="var(--color_dark)" />
          </button>
        )}
      </div>
    );
  },
);

export { MenuFooter };
